import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase/app'
import Clipboard from 'v-clipboard' 


Vue.use(Clipboard)


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  created(){
    var config = {
      apiKey: "AIzaSyCXWAQQXr4Fb17mb8JhFAfWfpVuIazb8wg",
      authDomain: "check-sampler.firebaseapp.com",
      databaseURL: "https://check-sampler.firebaseio.com",
      projectId: "check-sampler",
      storageBucket: "check-sampler.appspot.com",
      messagingSenderId: "1005078955065"
    };
    firebase.initializeApp(config);
  }
}).$mount('#app')

